import RegisterBanner from "../../components/banners/LoginBanner";
import LoginForm from "./LoginForm";

export default function Login() {
  return (
    <div>
      <RegisterBanner />
      <LoginForm />
    </div>
  );
}
